import { type User, Module } from 'api/data.types'
import {
  LIVROS_HOME_ROOT_PATH,
  ATUALIDADES_HOME_ROOT_PATH,
  SENTIR_HOME_ROOT_PATH,
  LER_HOME_ROOT_PATH,
  LER_REVISTAS_E_JORNAIS_HOME_ROOT_PATH,
  LER_NOTICIAS_HOME_ROOT_PATH,
  COMUNICAR_HOME_ROOT_PATH,
  ROOT_PATH
} from 'routes/paths'

const mapModuleToPath = {
  [LIVROS_HOME_ROOT_PATH]: 'LIVROS',
  [ATUALIDADES_HOME_ROOT_PATH]: 'ATUALIDADES',
  [COMUNICAR_HOME_ROOT_PATH]: 'ENGLISH',
  [SENTIR_HOME_ROOT_PATH]: 'SENTIR',
  [LER_HOME_ROOT_PATH]: 'LER',
  [LER_REVISTAS_E_JORNAIS_HOME_ROOT_PATH]: 'LER',
  [LER_NOTICIAS_HOME_ROOT_PATH]: 'LER'
  // TODO: alterar o módulo inglês para o módulo comunicar com a mudança no back
  // [COMUNICAR_HOME_ROOT_PATH]: 'ENGLISH'
}

const mapPathToModule = {
  LIVROS: LIVROS_HOME_ROOT_PATH,
  ATUALIDADES: ATUALIDADES_HOME_ROOT_PATH,
  ENGLISH: COMUNICAR_HOME_ROOT_PATH,
  SENTIR: SENTIR_HOME_ROOT_PATH,
  LER: LER_HOME_ROOT_PATH,
  COMUNICAR: COMUNICAR_HOME_ROOT_PATH
}

const getUserModules = user => user.reader.contentFilters

const getDefaultModule = (user: User) => {
  if (getUserModules(user)?.includes(Module.LER)) {
    return Module.LER
  }
  if (getUserModules(user)?.includes(Module.LIVROS)) {
    return Module.LIVROS
  }
  if (getUserModules(user)?.includes(Module.ATUALIDADES)) {
    return Module.ATUALIDADES
  }
  if (getUserModules(user)?.includes(Module.INGLES)) {
    return Module.INGLES
  }
  if (getUserModules(user)?.includes(Module.SENTIR)) {
    return Module.SENTIR
  }
  window.location.href = ROOT_PATH
}

const getDefaultModulePath = (user: User) => {
  return mapPathToModule[getDefaultModule(user)]
}

const userCanAccessModulePath = (user: User, modulePath: string) => {
  return getUserModules(user).includes(mapModuleToPath[modulePath])
}

const userHasOnlyCriarAccess = (user: User) => {
  const userModules = getUserModules(user)
  return userModules?.length === 1 && userModules.includes(Module.CRIAR)
}

const userHasOnlyWritingAccess = (user: User) => {
  const userModules = getUserModules(user)
  return userModules?.length === 1 && userModules.includes(Module.ESCRITA)
}

export default {
  getDefaultModule,
  getDefaultModulePath,
  userCanAccessModulePath,
  userHasOnlyCriarAccess,
  userHasOnlyWritingAccess
}
